import moment from 'moment';
import { createSelector } from 'reselect';
import type { EventsLogReduxState } from './types';

const eventsLogSelector = (state: EventsLogReduxState) => state.insights.events.eventsLog;

/**
 * selectEventsLog
 * Selects the eventsLog from the eventsLog state.
 */
export const selectEventsLog = createSelector([eventsLogSelector], (eventsLog) =>
  eventsLog.map((log, i) => {
    /** It was discovered that Safari cannot interpret the date format `yyyy-MM-DD hh:mm:ss +00:00`
     * due to the space before `+00:00`. The space technically does not comply with ISO 8601 standard,
     * even though Chrome has no problem parsing it. Reformat to match standard. */
    const formattedDate = moment(log.createdAt, 'yyyy-MM-DD hh:mm:ss Z').toDate().toISOString();
    return {
      ...log,
      /** Since the events returned from the API do not have a unique identifier, we add an id to each event so that the react table will render properly. */
      id: i,
      createdAt: formattedDate,
    };
  }),
);
